module.exports = __webpack_public_path__ + "static/media/mail-sent-pana-work.f0f7484a.svg";